// Lightweight manual route prefetch registry
// Maps path prefixes to dynamic importers matching lazy routes in App.jsx

const registry = [
  { test: p => p === '/' , load: () => import('../pages/Home') },
  { test: p => p.startsWith('/products') && !p.startsWith('/b2b'), load: () => Promise.all([
      import('../pages/ProductCatalog'),
      import('../pages/ProductDetail')
    ]) },
  { test: p => p === '/cart', load: () => import('../pages/Cart') },
  { test: p => p.startsWith('/checkout'), load: () => import('../pages/Checkout') },
  { test: p => p === '/login', load: () => import('../pages/auth/Login') },
  { test: p => p === '/register', load: () => import('../pages/auth/Register') },
  { test: p => p === '/profile', load: () => import('../pages/auth/Profile') },
  { test: p => p.startsWith('/orders'), load: () => Promise.all([
      import('../pages/OrderHistory'),
      import('../pages/OrderDetail')
    ]) },
  { test: p => p.startsWith('/b2b/dashboard'), load: () => import('../pages/b2b/B2BDashboard') },
  { test: p => p.startsWith('/b2b/quick-order'), load: () => import('../pages/b2b/B2BQuickOrder') },
  { test: p => p.startsWith('/b2b/products'), load: () => Promise.all([
      import('../pages/ProductCatalog'),
      import('../pages/ProductDetail')
    ]) },
  { test: p => p.startsWith('/b2b/apply'), load: () => import('../pages/b2b/B2BApplication') }
];

const inflight = new Set();

export function prefetchRoute(path) {
  if (!path) return;
  try {
    const match = registry.find(r => r.test(path));
    if (!match) return;
    const key = match.test.toString();
    if (inflight.has(key)) return;
    inflight.add(key);
    match.load().catch(()=>{}).finally(() => {
      // keep in set to avoid repeat network work this session
    });
  } catch {}
}

// Optional: observe viewport links for automatic prefetch
export function autoPrefetchLinks(root = document) {
  if (typeof IntersectionObserver === 'undefined') return;
  const observer = new IntersectionObserver(entries => {
    for (const e of entries) {
      if (e.isIntersecting) {
        const href = e.target.getAttribute('href');
        if (href && href.startsWith('/')) prefetchRoute(href);
      }
    }
  }, { rootMargin: '200px' });
  root.querySelectorAll('a[href^="/"]').forEach(a => observer.observe(a));
  return () => observer.disconnect();
}
